<div class="notification-panel">
  <div class="panel-header">
    <h2 class="text-2xl font-bold">Send Notification</h2>
  </div>

  <div *ngIf="errorMessage" class="alert alert-error">
    <i class='bx bx-error-circle'></i>
    {{ errorMessage }}
  </div>
  <div *ngIf="successMessage" class="alert alert-success">
    <i class='bx bx-check-circle'></i>
    {{ successMessage }}
  </div>

  <div class="notification-form">
    <div class="form-section">
      <h3 class="section-title">VM Template</h3>

      <div class="form-group">
        <label>Select Template <span class="required">*</span></label>
        <div class="template-selector">
          <div class="search-input-wrapper">
            <input
              type="text"
              [(ngModel)]="templateSearchInput"
              (input)="onTemplateSearchInput(templateSearchInput)"
              (focus)="showTemplateDropdown = true"
              placeholder="Search and select a template"
              class="template-search-input">
            <i class='bx bx-chevron-down select-icon'></i>
            <button
              *ngIf="selectedTemplate"
              type="button"
              class="clear-selection"
              (mousedown)="$event.preventDefault(); clearTemplateSelection()"
              title="Clear selection">
              <i class='bx bx-x'></i>
            </button>
          </div>

          <div *ngIf="showTemplateDropdown" class="template-dropdown">
            <div *ngIf="filteredTemplates.length === 0" class="no-results">
              <i class='bx bx-search-alt'></i>
              <span>No templates found</span>
            </div>
            <div *ngFor="let template of filteredTemplates"
              class="template-option"
              (mousedown)="selectTemplate(template)">
              <div class="template-name">{{ template.name || template.emailTemplateName || 'Template #' + template.id }}</div>
              <div class="template-details">
                <span class="template-subject">{{ template.emailSubject || 'No subject' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedTemplate" class="template-preview">
        <h4>{{ selectedTemplate.name || selectedTemplate.emailTemplateName || 'Template #' + selectedTemplate.id }}</h4>
        <div class="preview-content">
          <div class="preview-item">
            <span class="label">Subject:</span>
            <span class="value">{{ selectedTemplate.emailSubject || 'No subject' }}</span>
          </div>
          <div class="preview-item">
            <span class="label">VM file:</span>
            <span class="value">{{ selectedTemplate.emailTemplateName || 'No VM file' }}</span>
          </div>
        </div>

        <div class="form-group schedule-group">
          <label>Schedule</label>
          <div class="schedule-toggle-container">
            <label class="toggle-option">
              <input
                type="radio"
                class="toggle-radio"
                name="notificationSchedule"
                [checked]="!scheduleForLater"
                (change)="scheduleForLater = false">
              <span class="toggle-label">
                <i class='bx bx-x-circle'></i>
                No
              </span>
            </label>
            <label class="toggle-option">
              <input
                type="radio"
                class="toggle-radio"
                name="notificationSchedule"
                [checked]="scheduleForLater"
                (change)="scheduleForLater = true">
              <span class="toggle-label">
                <i class='bx bx-calendar-event'></i>
                Yes
              </span>
            </label>
          </div>
          <input
            #scheduleDateInput
            *ngIf="scheduleForLater"
            type="date"
            [(ngModel)]="scheduleDate"
            [min]="getTomorrowDate()"
            (click)="openDatePicker(scheduleDateInput)"
            (focus)="openDatePicker(scheduleDateInput)"
            (ngModelChange)="onScheduleDateChange()"
            class="form-input date-picker">
          <div *ngIf="!scheduleForLater" class="schedule-note">
            Send immediately
          </div>
        </div>

        <div class="bulk-upload-panel">
          <div class="bulk-upload-header">
            <div>
              <h5>Bulk Upload</h5>
              <p>Download the CSV, keep the calendar loader fields, add recipient emails, then upload it with Load Multiple.</p>
            </div>
            <button type="button" class="btn-template-download" (click)="downloadTemplate()">
              <i class='bx bx-download'></i>
              Download
            </button>
          </div>

          <div class="template-fields-list">
            <span *ngFor="let attribute of loaderAttributes" class="template-field-pill">
              {{ getBulkUploadFieldLabel(attribute.name) }}<span *ngIf="!attribute.optional" class="star">*</span>
            </span>
          </div>
          <p *ngIf="loaderDefinitionError" class="error-text">{{ loaderDefinitionError }}</p>

          <label class="upload-area" for="bulkUploadFile">
            <i class='bx bx-cloud-upload'></i>
            <span class="upload-title">Choose CSV or JSON file</span>
            <span class="upload-hint">{{ getBulkUploadHint() }}</span>
          </label>
          <input
            #bulkUploadInput
            id="bulkUploadFile"
            type="file"
            class="file-input"
            accept=".csv,application/json,text/csv"
            (change)="onBulkUploadFileSelected($event)">

          <div *ngIf="bulkUploadFile" class="file-preview">
            <div class="file-info">
              <i class='bx bx-file'></i>
              <div>
                <p class="file-name">{{ bulkUploadFile.name }}</p>
                <p class="file-size">{{ bulkUploadFile.size | number }} bytes</p>
                <p class="file-size">{{ bulkUploadRecipients.length }} recipient(s) loaded</p>
              </div>
            </div>
            <button type="button" class="remove-file-btn" (click)="clearBulkUploadFile(bulkUploadInput)" title="Clear upload">
              <i class='bx bx-x'></i>
            </button>
          </div>

          <div class="bulk-upload-actions">
            <button
              type="button"
              class="btn-template-upload"
              [disabled]="!bulkUploadRecipients.length || isLoading"
              (click)="uploadBulkRecipients(bulkUploadInput)">
              <i class='bx bx-upload'></i>
              <span *ngIf="!isLoading">Upload</span>
              <span *ngIf="isLoading">Uploading...</span>
            </button>
          </div>

          <p *ngIf="bulkUploadError" class="error-text">{{ bulkUploadError }}</p>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3 class="section-title">User Search</h3>

      <div class="form-group">
        <label>Search User <span class="required">*</span></label>
        <div class="recipient-search-container">
          <div class="recipient-chips">
            <div *ngFor="let recipient of recipients" class="recipient-chip">
              <div class="chip-content">
                <span class="chip-name">{{ recipient.name || recipient.email }}</span>
                <span class="chip-email">{{ recipient.email }}</span>
                <span *ngIf="recipient.verified" class="chip-verified" title="Verified">
                  <i class='bx bx-check-circle'></i>
                </span>
              </div>
              <button
                type="button"
                class="chip-remove"
                (click)="removeRecipient(recipient.id)"
                title="Remove user">
                <i class='bx bx-x'></i>
              </button>
            </div>
          </div>

          <div class="search-input-wrapper">
            <input
              type="text"
              [(ngModel)]="searchInput"
              (input)="onSearchInput(searchInput)"
              (focus)="showSearchResults = true"
              (blur)="closeSearchResults()"
              placeholder="Search by name, email, mobile, or user ID"
              class="recipient-search-input">

            <div *ngIf="showSearchResults && (searchResults.length > 0 || isSearching || searchInput.trim().length > 2)" class="search-results-dropdown">
              <div *ngIf="isSearching" class="search-loading">
                <i class='bx bx-loader-alt animate-spin'></i>
                <span>Searching...</span>
              </div>

              <div *ngIf="!isSearching && searchResults.length > 0">
                <div *ngFor="let user of searchResults"
                  class="search-result-item"
                  (click)="addRecipient(user)">
                  <div class="result-avatar">
                    <i class='bx bx-user-circle'></i>
                  </div>
                  <div class="result-content">
                    <div class="result-name">{{ user.name || user.userName || user.email }}</div>
                    <div class="result-email">{{ user.email }}</div>
                  </div>
                  <div *ngIf="user.verified" class="result-verified">
                    <i class='bx bx-check-circle'></i>
                  </div>
                  <div *ngIf="!user.verified" class="result-unverified">
                    <i class='bx bx-question-mark'></i>
                  </div>
                </div>
              </div>

              <div *ngIf="!isSearching && searchResults.length === 0 && searchInput.trim().length > 2" class="no-results">
                <p>No users found matching your search</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="recipients.length > 0" class="recipients-count">
        <i class='bx bx-info-circle'></i>
        <span>{{ recipients.length }} user(s) selected</span>
      </div>
    </div>

    <div class="single-load-preview">
      <div>
        <h3 class="section-title">Send Payload</h3>
        <p>{{ scheduleForLater ? 'Endpoint: /greetingAndNotification/calendar' : (bulkUploadRecipients.length ? 'Endpoint: loadMultiple / GreetingsAndInformationBroadcaster' : 'Endpoint: loadSingle / GreetingsAndInformationBroadcaster') }}</p>
      </div>
      <pre>{{ getSingleLoadPreview() }}</pre>
    </div>

    <div class="form-actions">
      <button
        class="btn-send"
        (click)="sendNotification()"
        [disabled]="isLoading">
        <span *ngIf="!isLoading" class="flex items-center gap-2">
          <i class='bx bx-send'></i>
          Send
        </span>
        <span *ngIf="isLoading" class="flex items-center gap-2">
          <i class='bx bx-loader-alt animate-spin'></i>
          Loading...
        </span>
      </button>
      <button
        type="button"
        class="btn-reset"
        (click)="resetForm()"
        [disabled]="isLoading">
        Clear
      </button>
    </div>
  </div>
</div>
